import { useMemo } from "react";

export function StarField({ density = 60 }) {
  const stars = useMemo(() => {
    return Array.from({ length: density }).map((_, i) => ({
      id: i,
      top: Math.random() * 100,
      left: Math.random() * 100,
      size: Math.random() * 2 + 1,
      delay: Math.random() * 4,
      dur: Math.random() * 3 + 2,
    }));
  }, [density]);

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="absolute rounded-full animate-twinkle"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            background: s.id % 5 === 0 ? "#D3A84E" : "#E7D9F2",
            boxShadow: s.id % 5 === 0 ? "0 0 6px #D3A84E" : "0 0 4px rgba(231,217,242,0.8)",
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
          }}
        />
      ))}
    </div>
  );
}
